import { isArray } from 'lodash';
import { computed, ComputedRef, ref, Ref } from 'vue';
import { RouteLocationNormalized } from 'vue-router';

type NavigationHistory = {
    from: RouteLocationNormalized;
    to: RouteLocationNormalized;
}

const history: Ref<NavigationHistory[]> = ref([]);
const state: ComputedRef<NavigationHistory | null> = computed(() => {
    return history.value[history.value.length - 1] || null;
});

const onPage = (from: RouteLocationNormalized, to: RouteLocationNormalized): void => {
    history.value.push({ from, to });

    // Keep the history to a maximum of 30 items
    if (history.value.length > 30) {
        history.value.shift();
    }
};

const getParentAppendRoute = (ignorePrefix = ''): string => {
    const parts = state.value && state.value.to ? state.value.to.fullPath.split('/') : [];
    return parts.length && parts[1] && parts[1] !== ignorePrefix ? `${parts[1]}.` : '';
};

const getCurrentModule = (): string => {
    return getParentAppendRoute('my-profile').slice(0, -1);
};

const routeNameIncludes = (names: string | string[]) => {
    if (isArray(names)) {
        return names.some((name) => {
            return state.value?.to.name?.toString().includes(name);
        });
    }

    return state.value?.to.name?.toString().includes(names as string);
};

const routePathIncludes = (names: string | string[]) => {
    if (isArray(names)) {
        return names.some((name) => {
            return state.value?.to.path?.toString().includes(name);
        });
    }

    return state.value?.to.path?.toString().includes(names as string);
};

export {
    state,
    onPage,
    getParentAppendRoute,
    getCurrentModule,
    routeNameIncludes,
    routePathIncludes
};
